import { render } from "./Key6.vue?vue&type=template&id=b3aa13e6"
import script from "./Key6.vue?vue&type=script&lang=ts"
export * from "./Key6.vue?vue&type=script&lang=ts"
script.render = render

export default script